var _rect, _rect2, _path, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndividualfeature2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 127,
    viewBox: "0 0 32 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#A814DC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "black",
    strokeOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3145 20.3125V22H11.7363V20.5498L15.9023 16.0059C16.3594 15.4902 16.7197 15.0449 16.9834 14.6699C17.2471 14.2949 17.4316 13.958 17.5371 13.6592C17.6484 13.3545 17.7041 13.0586 17.7041 12.7715C17.7041 12.3672 17.6279 12.0127 17.4756 11.708C17.3291 11.3975 17.1123 11.1543 16.8252 10.9785C16.5381 10.7969 16.1895 10.7061 15.7793 10.7061C15.3047 10.7061 14.9062 10.8086 14.584 11.0137C14.2617 11.2188 14.0186 11.5029 13.8545 11.8662C13.6904 12.2236 13.6084 12.6338 13.6084 13.0967H11.4902C11.4902 12.3525 11.6602 11.6729 12 11.0576C12.3398 10.4365 12.832 9.94434 13.4766 9.58105C14.1211 9.21191 14.8975 9.02734 15.8057 9.02734C16.6611 9.02734 17.3877 9.1709 17.9854 9.45801C18.583 9.74512 19.0371 10.1523 19.3477 10.6797C19.6641 11.207 19.8223 11.8311 19.8223 12.5518C19.8223 12.9502 19.7578 13.3457 19.6289 13.7383C19.5 14.1309 19.3154 14.5234 19.0752 14.916C18.8408 15.3027 18.5625 15.6924 18.2402 16.085C17.918 16.4717 17.5635 16.8643 17.1768 17.2627L14.4082 20.3125H20.3145Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 32,
    width: 4,
    height: 95,
    fill: "#A814DC",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualfeature2);
export default __webpack_public_path__ + "static/media/Individual.feature2.4d064e7f2d7343ddd4b0190175ce2e72.svg";
export { ForwardRef as ReactComponent };